<div class="qa-container">
  <div class="qa-body confirmation-screen" *ngIf="isConfirmingClose">
    <div class="d-flex justify-content-between align-items-start mb-2">
      <p class="qa-question-text flex-1 m-0">
        <strong style="font-size: 15px; color: var(--neutral-800); display: block; margin-bottom: 4px"
          >Confirmation</strong
        >
        Would you like to continue without answering?
      </p>
    </div>
  </div>

  <div class="qa-body" *ngIf="!isConfirmingClose && currentQuestion as q">
    <div class="qa-header">
      <div class="d-flex justify-content-between align-items-start mb-2">
        <p class="qa-question-text flex-1 m-0">
          {{ !activeSession?.isOwner && isCollapsed ? 'Questions from Rai' : q.text }}
        </p>
        <div class="d-flex align-items-center ms-2" style="gap: 8px">
          <!-- Non-Owner Collapse Button -->
          <button
            *ngIf="!activeSession?.isOwner"
            class="qa-close-btn"
            (click)="toggleCollapse()"
            (keydown.enter)="toggleCollapse()"
            tabindex="0"
          >
            <svg
              *ngIf="isCollapsed"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.8334 5.83203L5.83337 0.832031L0.833374 5.83203"
                stroke="var(--neutral-700)"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              *ngIf="!isCollapsed"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.833313 0.832031L5.83331 5.83203L10.8333 0.832031"
                stroke="var(--neutral-700)"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- Owner Close Button -->
          <button
            *ngIf="activeSession?.isOwner"
            class="qa-close-btn"
            (click)="onCloseClick()"
            (keydown.enter)="onCloseClick()"
            tabindex="0"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 12 12" fill="none">
              <path
                d="M10.8333 0.832031L0.833252 10.832M0.833252 0.832031L10.8333 10.832"
                stroke="var(--neutral-700)"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="qa-options-scrollable-container" *ngIf="!isCollapsed">
      <!-- Multiple Choice -->
      <div class="qa-options" *ngIf="q.type === 'check-boxes'">
        <label class="qa-option-row mb-0" *ngFor="let opt of q.options" [class.selected]="isSelected(q.id, opt.id)">
          <input
            type="checkbox"
            [checked]="isSelected(q.id, opt.id)"
            (change)="toggleSelection(q.id, opt.id)"
            [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
          />
          <span class="opt-label">{{ opt.text }}</span>
        </label>

        <!-- Created Custom Options -->
        <ng-container *ngIf="q.config?.hideOthers !== 'true' && customOptions[q.id]?.length">
          <label
            class="qa-option-row mb-0 other-option"
            *ngFor="let cText of customOptions[q.id]; let i = index; trackBy: trackByIndex"
            [class.selected]="isSelected(q.id, '_custom_' + cText)"
          >
            <input
              type="checkbox"
              [checked]="isSelected(q.id, '_custom_' + cText)"
              (change)="toggleSelection(q.id, '_custom_' + cText)"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            />

            <ng-container *ngIf="!editingCustomOption[q.id + '_' + i]">
              <span class="opt-label flex-grow-1" style="margin-right: 8px">{{ cText }}</span>
              <div style="display: flex; align-items: center; gap: 4px; flex-shrink: 0" *ngIf="activeSession?.isOwner">
                <button
                  class="icon-btn edit-btn"
                  title="Edit"
                  (click)="$event.preventDefault(); startEditCustomOption(q.id, i, $event)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button
                  class="icon-btn remove-btn"
                  title="Remove"
                  (click)="
                    $event.preventDefault(); $event.stopPropagation(); removeCustomOption(q.id, i, 'check-boxes')
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="editingCustomOption[q.id + '_' + i]">
              <input
                type="text"
                class="qa-inline-custom-input inline-edit flex-1"
                [value]="cText"
                (keyup.enter)="saveCustomOptionEdit(q.id, i, $event, cText, 'check-boxes')"
                (blur)="saveCustomOptionEdit(q.id, i, $event, cText, 'check-boxes')"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
              />
              <button
                class="icon-btn remove-btn ms-2"
                title="Remove"
                (click)="$event.preventDefault(); $event.stopPropagation(); removeCustomOption(q.id, i, 'check-boxes')"
                *ngIf="activeSession?.isOwner"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </ng-container>
          </label>
        </ng-container>

        <!-- Custom Option Input Field -->
        <label class="qa-option-row mb-0 other-option-check-box input-row" *ngIf="q.config?.hideOthers !== 'true'">
          <input
            type="checkbox"
            disabled
            class="placeholder-checkbox"
            [checked]="(pendingOtherText[q.id] || '').trim().length > 0"
          />
          <div class="qa-inline-input-wrapper w-100 mb-0 flex-1">
            <input
              #otherCbInput
              type="text"
              class="qa-inline-custom-input"
              placeholder="Other"
              [(ngModel)]="pendingOtherText[q.id]"
              (keydown.enter)="$event.preventDefault(); addCustomOption(q.id, 'check-boxes'); otherCbInput.blur()"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            />
            <button
              class="icon-btn submit-custom-btn"
              title="Add"
              (click)="$event.preventDefault(); addCustomOption(q.id, 'check-boxes')"
              *ngIf="pendingOtherText[q.id]?.trim()?.length"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="9 10 4 15 9 20"></polyline>
                <path d="M20 4v7a4 4 0 0 1-4 4H4"></path>
              </svg>
            </button>
          </div>
        </label>
      </div>

      <!-- Single Choice -->
      <div class="qa-options" *ngIf="q.type === 'radio-buttons'">
        <label class="qa-option-row mb-0" *ngFor="let opt of q.options" [class.selected]="answers[q.id] === opt.id">
          <input
            type="radio"
            [value]="opt.id"
            [(ngModel)]="answers[q.id]"
            name="{{ q.id }}"
            (click)="toggleRadioSelection(q.id, opt.id, $event)"
            (change)="clearOther(q.id)"
            [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
          />
          <span class="opt-label">{{ opt.text }}</span>
        </label>

        <!-- Created Custom Options -->
        <ng-container *ngIf="q.config?.hideOthers !== 'true' && customOptions[q.id]?.length">
          <label
            class="qa-option-row mb-0 other-option"
            *ngFor="let cText of customOptions[q.id]; let i = index; trackBy: trackByIndex"
            [class.selected]="answers[q.id] === '_custom_' + cText"
          >
            <input
              type="radio"
              [value]="'_custom_' + cText"
              [(ngModel)]="answers[q.id]"
              name="{{ q.id }}"
              (click)="toggleRadioSelection(q.id, '_custom_' + cText, $event)"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            />

            <ng-container *ngIf="!editingCustomOption[q.id + '_' + i]">
              <span class="opt-label flex-grow-1" style="margin-right: 8px">{{ cText }}</span>
              <div style="display: flex; align-items: center; gap: 4px; flex-shrink: 0" *ngIf="activeSession?.isOwner">
                <button
                  class="icon-btn edit-btn"
                  title="Edit"
                  (click)="$event.preventDefault(); startEditCustomOption(q.id, i, $event)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button
                  class="icon-btn remove-btn"
                  title="Remove"
                  (click)="
                    $event.preventDefault(); $event.stopPropagation(); removeCustomOption(q.id, i, 'radio-buttons')
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </ng-container>

            <ng-container *ngIf="editingCustomOption[q.id + '_' + i]">
              <input
                type="text"
                class="qa-inline-custom-input inline-edit flex-1"
                [value]="cText"
                (keyup.enter)="saveCustomOptionEdit(q.id, i, $event, cText, 'radio-buttons')"
                (blur)="saveCustomOptionEdit(q.id, i, $event, cText, 'radio-buttons')"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
              />
              <button
                class="icon-btn remove-btn ms-2"
                title="Remove"
                (click)="
                  $event.preventDefault(); $event.stopPropagation(); removeCustomOption(q.id, i, 'radio-buttons')
                "
                *ngIf="activeSession?.isOwner"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </ng-container>
          </label>
        </ng-container>

        <!-- Custom Option Input Field -->
        <label
          class="qa-option-row mb-0 other-option-radio-button input-row"
          *ngIf="q.config?.hideOthers !== 'true' && (!customOptions[q.id] || customOptions[q.id]?.length === 0)"
        >
          <input
            type="radio"
            disabled
            class="placeholder-radio"
            [checked]="(pendingOtherText[q.id] || '').trim().length > 0"
          />
          <div class="qa-inline-input-wrapper w-100 mb-0 flex-1">
            <input
              #otherRadInput
              type="text"
              class="qa-inline-custom-input inline-radio"
              placeholder="Other"
              [(ngModel)]="pendingOtherText[q.id]"
              (focus)="answers[q.id] = null"
              (keydown.enter)="addCustomOption(q.id, 'radio-buttons'); otherRadInput.blur()"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            />
            <button
              class="icon-btn submit-custom-btn"
              title="Add"
              (click)="addCustomOption(q.id, 'radio-buttons')"
              *ngIf="pendingOtherText[q.id]?.trim()?.length"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="9 10 4 15 9 20"></polyline>
                <path d="M20 4v7a4 4 0 0 1-4 4H4"></path>
              </svg>
            </button>
          </div>
        </label>
      </div>

      <!-- Open Ended -->
      <div class="qa-options" *ngIf="q.type === 'textarea'">
        <textarea
          class="qa-textarea"
          placeholder="Type your answer..."
          [(ngModel)]="answers[q.id]"
          (input)="autoGrowTextarea($event)"
          [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
        ></textarea>
      </div>

      <!-- Chip Selection -->
      <div class="question-type-chip" *ngIf="q.type === 'chips'">
        <div class="qa-chip-options mb-2">
          <button
            class="qa-chip"
            *ngFor="let opt of q.options"
            [class.selected]="isSelected(q.id, opt.id)"
            (click)="toggleSelection(q.id, opt.id)"
            [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
          >
            {{ opt.text }}
          </button>

          <!-- Created Custom Options -->
          <ng-container *ngIf="q.config?.hideOthers !== 'true' && customOptions[q.id]?.length">
            <ng-container *ngFor="let cText of customOptions[q.id]; let i = index; trackBy: trackByIndex">
              <button
                *ngIf="!editingCustomOption[q.id + '_' + i]"
                class="qa-chip custom-chip"
                [class.selected]="isSelected(q.id, '_custom_' + cText)"
                (click)="toggleSelection(q.id, '_custom_' + cText)"
                [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
              >
                <span class="flex-1 text-start" style="margin-right: 6px">{{ cText }}</span>
                <span class="d-flex align-items-center" style="gap: 4px" *ngIf="activeSession?.isOwner">
                  <span
                    class="icon-btn edit-btn"
                    title="Edit"
                    tabindex="0"
                    role="button"
                    (keydown.enter)="$event.stopPropagation(); startEditCustomOption(q.id, i, $event)"
                    (click)="$event.stopPropagation(); startEditCustomOption(q.id, i, $event)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </span>
                  <span
                    class="icon-btn remove-btn"
                    title="Remove"
                    tabindex="0"
                    role="button"
                    (keydown.enter)="$event.stopPropagation(); removeCustomOption(q.id, i, 'chips')"
                    (click)="$event.stopPropagation(); removeCustomOption(q.id, i, 'chips')"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </span>
                </span>
              </button>

              <div class="qa-options" style="width: 100%" *ngIf="editingCustomOption[q.id + '_' + i]">
                <label class="qa-option-row mb-0 other-option mt-1">
                  <input
                    type="text"
                    class="qa-inline-custom-input inline-edit flex-1"
                    [value]="cText"
                    (keyup.enter)="saveCustomOptionEdit(q.id, i, $event, cText, 'chips')"
                    (blur)="saveCustomOptionEdit(q.id, i, $event, cText, 'chips')"
                    (click)="$event.preventDefault(); $event.stopPropagation()"
                    [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
                  />
                  <button
                    class="icon-btn remove-btn ms-2"
                    title="Remove"
                    (click)="$event.preventDefault(); $event.stopPropagation(); removeCustomOption(q.id, i, 'chips')"
                    *ngIf="activeSession?.isOwner"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                </label>
              </div>
            </ng-container>
          </ng-container>

          <!-- Custom Option Input Field -->
          <div class="chip-add-other" *ngIf="q.config?.hideOthers !== 'true'">
            <div
              style="
                position: absolute;
                left: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                pointer-events: none;
                color: var(--neutral-400);
              "
            >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.49998 13.591H14.25M0.75 13.591H2.00591C2.37279 13.591 2.55624 13.591 2.72887 13.5495C2.88192 13.5128 3.02824 13.4522 3.16245 13.37C3.31382 13.2772 3.44354 13.1475 3.70296 12.888L13.125 3.46599C13.7463 2.84467 13.7463 1.83731 13.125 1.21599C12.5037 0.59467 11.4963 0.59467 10.875 1.21599L1.45295 10.638C1.19352 10.8975 1.0638 11.0272 0.97104 11.1786C0.888797 11.3128 0.82819 11.4591 0.791445 11.6121C0.75 11.7848 0.75 11.9682 0.75 12.3351V13.591Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <input
              #otherChipInput
              type="text"
              class="qa-inline-custom-input"
              placeholder="Other"
              [(ngModel)]="pendingOtherText[q.id]"
              (keydown.enter)="$event.preventDefault(); addCustomOption(q.id, 'chips'); otherChipInput.blur()"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            />
            <button
              class="icon-btn submit-custom-btn"
              title="Add"
              (click)="$event.preventDefault(); addCustomOption(q.id, 'chips')"
              *ngIf="pendingOtherText[q.id]?.trim()?.length"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="9 10 4 15 9 20"></polyline>
                <path d="M20 4v7a4 4 0 0 1-4 4H4"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Slider -->
      <div class="qa-slider-container" *ngIf="q.type === 'slider' && isSliderConfigValid(q)">
        <div class="qa-slider-boxes">
          <button
            class="qa-slider-box"
            *ngFor="let val of getSliderOptions(q)"
            [class.selected]="answers[q.id] === val"
            (click)="toggleSlider(q.id, val)"
            [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
          >
            {{ val }}
          </button>
        </div>
        <div class="qa-slider-labels" *ngIf="q.config?.labels">
          <span>{{ q.config.labels.low }}</span>
          <span>{{ q.config.labels.high }}</span>
        </div>
      </div>
      <div class="qa-slider-fallback" *ngIf="q.type === 'slider' && !isSliderConfigValid(q)">
        <p
          style="
            color: #64748b;
            font-size: 13px;
            text-align: center;
            border: 1px dashed #e2e8f0;
            border-radius: 8px;
            padding: 12px;
            margin: 0;
          "
        >
          This slider question will be bypassed, due to incorrect configuration
        </p>
      </div>

      <!-- Yes/No checklist -->
      <div class="qa-yesno-options" *ngIf="q.type === 'yes-no' && q.options">
        <div class="qa-yesno-row" *ngFor="let item of q.options" [class.selected]="hasYesNoAnswer(q.id, item.id)">
          <span class="Item-label">{{ item.text }}</span>
          <div class="yesno-actions">
            <button
              class="yesno-btn cross"
              [class.active]="getYesNoAnswer(q.id, item.id) === 'false'"
              (click)="setYesNo(q.id, item.id, 'false')"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            >
              <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.75 0.75L0.75 7.75M0.75 0.75L7.75 7.75"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              class="yesno-btn check"
              [class.active]="getYesNoAnswer(q.id, item.id) === 'true'"
              (click)="setYesNo(q.id, item.id, 'true')"
              [disabled]="appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS || !activeSession?.isOwner"
            >
              <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0833 0.75L3.66667 7.16667L0.75 4.25"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="qa-footer justify-content-end" *ngIf="isConfirmingClose">
    <div class="d-flex align-items-center" style="gap: 8px">
      <button class="qa-action-btn" (click)="isConfirmingClose = false">Cancel</button>
      <button class="qa-action-btn submit-btn" (click)="submitForm(true)">Yes</button>
    </div>
  </div>

  <div class="qa-footer" *ngIf="!isConfirmingClose && !isCollapsed">
    <button class="qa-action-btn" (click)="back()" *ngIf="currentIndex > 0">Back</button>
    <div class="spacer" *ngIf="currentIndex === 0"></div>

    <div class="qa-dots" *ngIf="totalCount > 1">
      <span
        class="dot"
        *ngFor="let d of [].constructor(totalCount); let idx = index"
        [class.active]="idx === currentIndex"
        [class.answered]="hasAnsweredQuestion(questions[idx])"
      ></span>
    </div>

    <div class="d-flex align-items-center" style="gap: 8px">
      <ng-container *ngIf="currentIndex < totalCount - 1; else lastQNext">
        <button
          class="qa-action-btn"
          [class.next-btn]="activeSession?.isOwner"
          (click)="skip()"
          *ngIf="
            !activeSession.isOwner ||
              appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS ||
              hasAnsweredCurrent();
            else skipBtn
          "
        >
          Next
        </button>
        <ng-template #skipBtn>
          <button class="qa-action-btn" (click)="skip()">Skip</button>
        </ng-template>
      </ng-container>
      <ng-template #lastQNext>
        <button
          class="qa-action-btn"
          disabled
          style="cursor: not-allowed; border-color: var(--neutral-100); color: var(--neutral-300)"
          *ngIf="!activeSession?.isOwner || appDetail?.mergeStatus === SESSION_MERGE_STATUS.IN_PROGRESS"
        >
          Next
        </button>
      </ng-template>

      <button
        class="qa-action-btn submit-btn"
        (click)="submitForm()"
        *ngIf="
          currentIndex === totalCount - 1 &&
          activeSession?.isOwner &&
          appDetail?.mergeStatus !== SESSION_MERGE_STATUS.IN_PROGRESS
        "
      >
        <span>Submit</span>
      </button>
    </div>
  </div>
</div>
